module.exports = __webpack_public_path__ + "img/ico-qr-code.070bfa1b.svg";